import { styled } from 'styled-components';

import { WaveIcon as Wave } from '@components/web/src/atoms/Icons/WaveIcon';
import { RETAILER_COLORS, SCREEN_SIZE } from '@components/web/src/styles';

export const FooterKioskContainer = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 9998;
  width: 100%;
  max-width: ${SCREEN_SIZE.KIOSK_WIDTH};
`;

export const WaveIcon = styled(Wave)`
  margin-bottom: -5px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 2.65px;
  padding: 7px 16px 12.35px;
  margin: 0 auto;
  background-color: ${RETAILER_COLORS.primary['800']};
`;

export const LinksWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 32px;
  justify-content: center;
`;

export const Link = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
